module.exports = __webpack_public_path__ + "static/media/modal-bg-children.0d6e9519.png";